import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"

import DeleteModal from "pages/parts/DeleteModal"
import { httpOk, GET, DELETE } from "helpers/api"

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function getData() {
		const response = await GET("/cheque-templates", {}, { loader: true })
		if (httpOk(response)) setData(response.data.data)
	}

	async function deleteItem() {
		const response = await DELETE(`/cheque-templates/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			getData()
			setModalDelete(false)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t("cheque_template")} [{data.length}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/cheque-templates/create">
						{t("create")}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: "33px" }} className="text-center">#</th>
									<th style={{ width: "28%" }}>{t("name2")}</th>
									<th style={{ width: "52%" }}>{t("description")}</th>
									<th style={{ minWidth: "100px" }} className="text-center">{t("status")}</th>
									<th style={{ minWidth: "100px" }} className="text-center text-nowrap">{t("default")}</th>
									<th style={{ minWidth: "33px" }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={item.id ?? index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<Link
												to={`/cheque-templates/update/${item.id}`}
												className="text-primary text-decoration-none fw-500">
												{item.name}
											</Link>
										</td>
										<td className="td-ellipsis">{item.description}</td>
										<td className="text-center">
											{item.is_active === false ? (
												<span className="bg-danger bg-border"></span>
											) : (
												<span className="bg-primary bg-border"></span>
											)}
										</td>
										<td className="text-center">
											{item.is_default ? (
												<span className="bg-primary bg-border"></span>
											) : (
												<span className="bg-secondary bg-border"></span>
											)}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`cheque-template-dd-${item.id ?? index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Link
															className="table-dropdown-item"
															to={`/cheque-templates/update/${item.id}`}
														>
															<i className="uil-edit-alt"></i>
															{t("edit")}
														</Link>
														<div
															className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index })
																setModalDelete(true)
															}}>
															<i className="uil uil-times"></i>
															{t("delete")}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								{!data.length && (
									<tr>
										<td colSpan={6} className="text-center text-muted">
											{t("list_empty")}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}
			/>
		</>
	)
}

export default Index
